var render = function render2() {
  var _vm = this, _c = _vm._self._c;
  return _c("form", { on: { "submit": function($event) {
    $event.preventDefault();
    return _vm.submit.apply(null, arguments);
  } } }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
